var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
var LocalizedDatePipe = /** @class */ (function (_super) {
    __extends(LocalizedDatePipe, _super);
    function LocalizedDatePipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalizedDatePipe.prototype.transform = function (value, pattern) {
        if (pattern === void 0) { pattern = 'yyyy-MM-dd H:mm'; }
        return _super.prototype.transform.call(this, value, pattern);
    };
    return LocalizedDatePipe;
}(DatePipe));
export { LocalizedDatePipe };
